import { Loader2 } from "lucide-react";
import type { ImgHTMLAttributes } from "react";

type AttachmentImageProps = {
  url?: string | null;
  isProcessing?: boolean;
  alt?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

const AttachmentImage: React.FC<AttachmentImageProps> = ({
  url,
  isProcessing,
  alt = "Image is processing",
  className,
  ...imgProps
}) => {
  const hasLocalPreview = !!url && (url.startsWith("blob:") || url.startsWith("data:"));

  if (isProcessing && !hasLocalPreview) {
    const { onClick, onKeyDown, tabIndex, title, role, style } = imgProps;
    return (
      <div
        role={role ?? "img"}
        aria-label={alt}
        title={title}
        tabIndex={tabIndex}
        onClick={onClick}
        onKeyDown={onKeyDown}
        style={style}
        className={`flex items-center justify-center bg-muted ${className ?? ""}`}
      >
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!url) {
    return null;
  }

  return <img src={url} alt={alt} className={className} {...imgProps} />;
};

export default AttachmentImage;
